import { Controller } from 'stimulus';
import { spreeApiController } from "../packs/scripts/SpreeApiController";
import { notyController } from "../packs/scripts/NotyController";
import {accounting} from "accounting";

export default class extends Controller {
  static targets = ['applyCouponCode', 'removeCouponCode', 'couponForm', 'couponCode', 'errorField',
                            'errorFieldButtons', 'freeDeliveryBar']

  connect(){
    if (this.hasRemoveCouponCodeTarget) this.hideCouponCodeForm();
  }

  async applyCouponCodeWithCheckout(event) {
    await this.ensureOrderToken();

    const headers = spreeApiController.prepareHeaders();
    const couponCode = this.couponCodeTarget.value.toUpperCase();
    const body = {
      "coupon_code": couponCode
    }

    const source = await fetch(`/api/v2/storefront/cart/apply_coupon_code`, {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify(body)
    });

    const response = await this.handleApplyCouponResponse(source, couponCode);

    if (response !== 200) return;

    const navigationButton = document.getElementById('navigationSubmitButton');
    navigationButton.form.submit();
  }


  async applyCouponCode(event) {
    if (event.keyCode !== 13 && event.keyCode !== undefined) return ;

    await this.ensureOrderToken();

    const headers = spreeApiController.prepareHeaders();
    const couponCode = this.couponCodeTarget.value.toUpperCase();
    const body = {
      "coupon_code": couponCode
    }

    const source = await fetch(`/api/v2/storefront/cart/apply_coupon_code`, {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify(body)
    });

    await this.handleApplyCouponResponse(source, couponCode);

    return source;
  }

  async handleApplyCouponResponse(source, couponCode) {
    const json = await source.json();
    const errorElement = this.couponCodeTarget.parentElement.querySelector('.formError');
    const errorElementRegistration = this.errorFieldTarget;
    const errorElementRegistrationButtons = this.errorFieldButtonsTarget;
    if (source.status === 422) {
      if (json.errors.no_user_specified) {
        this.hideFormErrorMessage(errorElement);
        this.showFormErrorMessage(errorElementRegistration, json.errors.no_user_specified[0]);
        errorElementRegistrationButtons.style.display = 'flex';
      } else {
        this.hideFormErrorMessage(errorElementRegistration);
        this.hideFormErrorMessage(errorElementRegistrationButtons);
        this.showFormErrorMessage(errorElement, json.errors.base[0]);
      }
      return source.status;
    }
    if (source.status !== 200) return source.status;

    const orderPromotion = this.findAppliedOrderPromotion(json, couponCode);
    if (orderPromotion === undefined) return;

    this.appendAppliedCoupon(orderPromotion);
    this.buildFreeDeliveryBar(json.data.attributes)
    this.hideCouponCodeForm();
    this.updateOrderTotal(json);
    this.hideFormErrorMessage(errorElement);
    this.hideFormErrorMessage(errorElementRegistration);
    this.hideFormErrorMessage(errorElementRegistrationButtons);
    this.clearCouponCodeField();

    notyController.show('success', this.applySuccessMessage());

    return source.status;
  }

  findAppliedOrderPromotion(json, couponCode) {
    const appliedOrderPromotion = json.data.attributes.order_promotions.filter(function(orderPromotion) {
      return orderPromotion.attributes.code.toUpperCase() == couponCode
    })[0];

    return appliedOrderPromotion?.attributes;
  }

  appendAppliedCoupon(orderPromotion){
    const coupons = document.querySelector('#applied-coupons');

    const newCoupon = document.createElement('div');

    newCoupon.id = 'applied-coupon-with-code';
    newCoupon.classList = 'flex justify-between';
    newCoupon.innerHTML = this.couponTemplate(orderPromotion);

    coupons.appendChild(newCoupon);
  }

  hideCouponCodeForm() {
    this.couponFormTarget.style.display = "none";
  }

  applySuccessMessage() {
    return this.couponCodeTarget.dataset.applySuccessMessage;
  }

  async removeCouponCode() {
    await this.ensureOrderToken();
    const headers = spreeApiController.prepareHeaders();

    const couponCode = this.removeCouponCodeTarget.dataset.couponCode;

    const source = await fetch(`/api/v2/storefront/cart/remove_coupon_code/${couponCode}`, {
      method: 'DELETE',
      headers: headers
    });

    await this.handleRemoveCouponResponse(source);

    return source;
  }

  async handleRemoveCouponResponse(source) {
    const json = await source.json();
    switch (source.status) {
      case 422:
        break;
      case 404:
        break;
      case 500:
        break;
      case 200:
        notyController.show('success', this.removeSuccessMessage());

        this.removeCoupon();
        this.buildFreeDeliveryBar(json.data.attributes)
        this.showCouponCodeForm();
        this.updateOrderTotal(json);

        break;
    }
  }

  showFormErrorMessage(errorElement, message) {
    errorElement.innerText = message;
    errorElement.style.display = "block";
  }

  hideFormErrorMessage(errorElement) {
    errorElement.style.display = 'none';
  }

  clearCouponCodeField() {
    this.couponCodeTarget.value = '';
  }

  removeSuccessMessage() {
    return this.couponCodeTarget.dataset.removeSuccessMessage;
  }

  removeCoupon() {
    const coupon = this.removeCouponCodeTarget.parentElement.parentElement.parentElement;
    coupon.remove();
  }

  showCouponCodeForm() {
    this.couponFormTarget.style.display = "block";
  }

  couponTemplate(orderPromotion) {
    var label = "Kupon"
    if (orderPromotion.promotion_actions.includes("Spree::Promotion::Actions::FreeShipping")) label = "Besplatna dostava"
    return `<span class="delivery-cart__total-price__price-label">${label}</span>
            <div class="d-flex flex-column items-end">
              <span class="delivery-cart__total-price__price-value flex justify-end">
                ${orderPromotion.display_amount}
              </span>
              <div class="flex items-center gap-10px">
                <span class="delivery-cart__total-price__cart-cupon">
                  ${orderPromotion.code}
                </span>
                <button type="button" class="icon delivery-cart__total-price__btn-remove-cupon"
                data-order-coupons-target="removeCouponCode" data-coupon-code="${orderPromotion.code}"
                data-action="click->order-coupons#removeCouponCode">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                    <path d="M1.7 17L0 15.3L6.8 8.5L0 1.7L1.7 0L8.5 6.8L15.3 0L17 1.7L10.2 8.5L17 15.3L15.3 17L8.5 10.2L1.7 17Z" fill="#D30C0C"></path>
                  </svg>
                </button>
              </div>
            </div>`
  }

  updateOrderTotal(json) {
    const navBarCart = document.getElementById('js-navbar-cart-button-display-total');
    if (navBarCart) {
      navBarCart.innerHTML = json.meta.price_total;
    }

    const orderTotal = document.getElementById('summary-order-total-sidebar');
    if (orderTotal) {
      orderTotal.innerHTML = json.meta.price_total;
    }
  }

  async ensureOrderToken() {
    if (spreeApiController.orderToken.length === 0) {
      const source = await fetch(`/ensure_cart`, {method: 'POST'});
      const data = await source.json();

      spreeApiController.orderToken = data.token
    }
  }

  buildFreeDeliveryBar(data) {
    if (!(this.hasFreeDeliveryBarTarget)) return

    if (parseFloat(data.shipping_total) > 0) {
      this.freeDeliveryBarTarget.innerHTML = this.readjustedFreeDeliveryBar(data.shipping_cost,
                                                                            data.amount,
                                                                            data.free_delivery_min_amount)
    } else {
      this.freeDeliveryBarTarget.innerHTML = this.readjustedFreeDeliveryBar(0,
                                                                            data.amount,
                                                                            0)
    }
  }

  readjustedFreeDeliveryBar(shippingCost, orderTotal, freeDeliveryMinimum) {
    if (freeDeliveryMinimum === null) {
      return " "
    }
    var freeDeliveryPercentage = 100
    var freeDeliveryTotalAmount = 0
    if (shippingCost > 0) {
      var freeDeliveryAmount = parseFloat(freeDeliveryMinimum)
      freeDeliveryPercentage = Math.round(((orderTotal / freeDeliveryAmount) * 100))
      freeDeliveryTotalAmount = (freeDeliveryAmount - orderTotal).toFixed(2)
    }

    if (freeDeliveryPercentage > 100) {
      freeDeliveryPercentage = 100
      freeDeliveryTotalAmount = 0
    }

    return this.freeDeliveryBarTemplate(freeDeliveryPercentage, freeDeliveryTotalAmount)
  }

  freeDeliveryBarTemplate(freeDeliveryPercentage, freeDeliveryTotalAmount) {
    var deliveryBarMessage = ''

    if (freeDeliveryPercentage === 100) {
      deliveryBarMessage = `Dostava je <strong>besplatna</strong>.`
    } else {
      deliveryBarMessage = `Do <strong> besplatne dostave</strong> nedostaje vam <strong>${freeDeliveryTotalAmount} €</strong>.`
    }

    return `<p>
              <span>
                ${deliveryBarMessage}
              </span>
            </p>
            <div class="delivery-cart__free-delivery__percent-box">
              <div class="delivery-cart__free-delivery__percent-box-percent" style="width: ${freeDeliveryPercentage}% !important;">
              </div>
            </div>`
  }
}
